module.exports = __webpack_public_path__ + "static/media/galaxyvr2x.0af499b3.png";